/* CLOVR - thème Shopify. JavaScript sans dépendance. */
(() => {
  'use strict';
  const C = window.CLOVR || {};
  const R = C.routes || { root: '/', cart: '/cart', cartJs: '/cart.js', cartAdd: '/cart/add.js', cartChange: '/cart/change.js' };
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fmt = new Intl.NumberFormat(C.locale || 'fr', { style: 'currency', currency: C.currency || 'EUR' });
  const money = cents => fmt.format(cents / 100);
  const esc = s => String(s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const JSON_HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' };

  /* ---------------------------------------------------------------- toast */
  let toastTimer;
  function toast(msg) {
    const t = $('[data-toast]'); if (!t) return;
    t.textContent = msg; t.classList.add('show');
    clearTimeout(toastTimer); toastTimer = setTimeout(() => t.classList.remove('show'), 3000);
  }

  /* ----------------------------------------------------------------- cart */
  let lastFocus = null;
  const drawerEl = () => $('[data-cart-drawer]');
  function applyDrawerState() {
    const open = document.body.classList.contains('cart-open');
    const d = drawerEl(); if (!d) return;
    d.setAttribute('aria-hidden', String(!open)); d.inert = !open;
  }
  function setDrawer(open) {
    document.body.classList.toggle('cart-open', open);
    applyDrawerState();
    const d = drawerEl(); if (!d) return;
    if (open) { lastFocus = document.activeElement; const c = $('.x', d); if (c) c.focus(); }
    else if (lastFocus && document.contains(lastFocus)) lastFocus.focus();
  }
  async function refreshCart() {
    const ids = ['cart-drawer', 'header'];
    if (document.getElementById('shopify-section-main-cart')) ids.push('main-cart');
    try {
      const res = await fetch(`${location.pathname}?sections=${ids.join(',')}`, { headers: { Accept: 'application/json' } });
      if (!res.ok) throw new Error('sections');
      const data = await res.json();
      ids.forEach(id => {
        const host = document.getElementById('shopify-section-' + id);
        if (!host || !data[id]) return;
        const doc = new DOMParser().parseFromString(data[id], 'text/html');
        const next = doc.getElementById('shopify-section-' + id);
        host.innerHTML = next ? next.innerHTML : data[id];
      });
      applyDrawerState();
    } catch (_) { location.reload(); }
  }
  async function changeLine(line, quantity) {
    try {
      const res = await fetch(R.cartChange, { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ line: Number(line), quantity: Number(quantity) }) });
      if (!res.ok) { const d = await res.json().catch(() => ({})); toast(d.description || d.message || 'Impossible de modifier la quantité.'); }
    } catch (_) { toast('Connexion impossible. Réessaie.'); }
    await refreshCart();
  }
  async function addToCart(form) {
    const root = form.closest('[data-product-root]');
    const btn = $('[data-add]', form), err = $('[data-errors]', form);
    const id = Number($('[data-variant-id]', form).value);
    if (err) { err.hidden = true; err.textContent = ''; }
    btn.disabled = true;
    try {
      const res = await fetch(R.cartAdd, { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ items: [{ id, quantity: 1 }] }) });
      const data = await res.json().catch(() => ({}));
      if (!res.ok || data.status) throw new Error(data.description || data.message || "Impossible d'ajouter ce produit au panier.");
      await refreshCart();
      closeDialogs();
      setDrawer(true);
    } catch (e) {
      if (err) { err.textContent = e.message; err.hidden = false; } else toast(e.message);
    } finally { updateVariant(root, { keepUrl: true }); }
  }

  /* ------------------------------------------------------------ dialogs */
  function closeDialogs() { $$('dialog[open]').forEach(d => d.close()); }
  async function openQV(url) {
    const dlg = $('#clovr-qv');
    if (!dlg || typeof dlg.showModal !== 'function') { location.href = url; return; }
    const body = $('[data-qv-body]', dlg);
    body.innerHTML = '<p class="muted" style="padding:2rem">Chargement…</p>';
    if (!dlg.open) dlg.showModal();
    try {
      const res = await fetch(url, { headers: { Accept: 'text/html' } });
      if (!res.ok) throw new Error('http');
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const root = doc.querySelector('[data-product-root]');
      if (!root) throw new Error('root');
      const h1 = root.querySelector('h1');
      if (h1) { const h2 = doc.createElement('h2'); h2.className = h1.className; h2.innerHTML = h1.innerHTML; h1.replaceWith(h2); }
      body.innerHTML = '';
      body.appendChild(document.importNode(root, true));
      updateVariant($('[data-product-root]', body), { keepUrl: true });
    } catch (_) { dlg.close(); location.href = url; }
  }

  /* ------------------------------------------------------------ variants */
  const dataCache = new WeakMap();
  function productData(root) {
    if (dataCache.has(root)) return dataCache.get(root);
    let p = null;
    try { p = JSON.parse($('[data-product-json]', root).textContent); } catch (_) { p = null; }
    if (p) p.variants.forEach(v => { v._o = (v.options && v.options.length) ? v.options : [v.option1, v.option2, v.option3].filter(x => x != null); });
    dataCache.set(root, p); return p;
  }
  const selection = root => $$('.opt', root).map(g => { const c = $('input:checked', g); return c ? c.value : null; });
  function setMedia(root, btn) {
    const main = $('[data-main-image] img', root); if (!main || !btn) return;
    main.src = btn.dataset.src; main.removeAttribute('srcset'); main.removeAttribute('sizes'); main.alt = btn.dataset.alt || '';
    $$('.qv-thumbs button', root).forEach(b => b.setAttribute('aria-current', String(b === btn)));
  }
  function updateVariant(root, opts = {}) {
    if (!root) return;
    const p = productData(root); if (!p) return;
    const sel = selection(root);
    const variant = sel.length ? p.variants.find(v => sel.every((s, i) => s === v._o[i])) : p.variants[0];
    // availability of each option value, given the other selected options
    $$('.opt', root).forEach((group, i) => {
      $$('input', group).forEach(input => {
        const ok = p.variants.some(v => v._o[i] === input.value && sel.every((s, j) => j === i || s === v._o[j]) && v.available);
        const label = input.nextElementSibling; if (label) label.classList.toggle('is-soldout', !ok);
      });
    });
    const available = !!(variant && variant.available);
    const idEl = $('[data-variant-id]', root); if (idEl && variant) idEl.value = variant.id;
    const priceEl = $('[data-price]', root);
    if (priceEl && variant) priceEl.innerHTML = (variant.compare_at_price > variant.price && available ? `<s>${money(variant.compare_at_price)}</s> ` : '') + money(variant.price);
    const add = $('[data-add]', root);
    if (add) { add.disabled = !available; add.textContent = !variant ? 'Indisponible' : (available ? 'Ajouter au panier' : 'Épuisé'); }
    const alert = $('[data-alert]', root); if (alert) alert.hidden = available;
    const body = $('[data-alert-body]', root);
    if (body && variant) body.value = `Alerte retour en stock : ${p.title} / ${variant.title} / ${location.origin}${p.url || ''}`;
    if (variant && variant.featured_image) setMedia(root, $(`.qv-thumbs button[data-media-id="${variant.featured_image.id}"]`, root));
    if (!opts.keepUrl && variant && !root.closest('dialog')) {
      try { history.replaceState(null, '', `${location.pathname}?variant=${variant.id}`); } catch (_) { /* ignore */ }
    }
  }
  async function sendAlert(form) {
    const msg = $('[data-alert-msg]', form), email = $('input[type=email]', form), btn = $('button[type=submit]', form);
    if (!email.value || !email.checkValidity()) { msg.textContent = 'Entre une adresse e-mail valide, par exemple prenom@email.fr.'; email.focus(); return; }
    btn.disabled = true; msg.textContent = 'Envoi en cours…';
    try {
      const res = await fetch(form.action, { method: 'POST', body: new FormData(form), headers: { Accept: 'text/html' } });
      if (res.ok && /contact_posted=true/.test(res.url)) { msg.textContent = "Merci, ta demande est transmise à notre équipe."; email.value = ''; }
      else throw new Error('post');
    } catch (_) { msg.textContent = "L'envoi n'a pas abouti. Réessaie, ou écris-nous depuis la page Contact."; }
    btn.disabled = false;
  }

  /* ---------------------------------------------------------- size guide */
  let SG = null;
  const sgState = { sleeve: 'long', root: null, hit: null, vals: { chest: '', waist: '', hips: '' } };
  const MLABEL = { chest: 'Poitrine', waist: 'Taille', hips: 'Hanches' };
  function sgData() {
    if (SG) return SG;
    try { SG = JSON.parse($('#clovr-size-data').textContent); } catch (_) { SG = null; }
    return SG;
  }
  function sizeFor(kind, v) {
    const e = SG.edges[kind], n = SG.sizes.length;
    if (v < e[0]) return { i: 0, note: 'low' };
    if (v >= e[e.length - 1]) return { i: n - 1, note: 'high' };
    let i = 0; for (let k = 0; k < n; k++) if (v >= e[k]) i = k;
    return { i, note: null };
  }
  function tableHTML(d) {
    return `<div class="tbl"><table><thead><tr>${d.cols.map(c => `<th scope="col">${esc(c)}</th>`).join('')}</tr></thead><tbody>${
      d.rows.map((r, i) => `<tr class="${sgState.hit === i ? 'hit' : ''}">${r.map((c, k) => k === 0 ? `<th scope="row">${esc(c)}</th>` : `<td>${esc(c)}</td>`).join('')}</tr>`).join('')}</tbody></table></div>`;
  }
  function renderSgTables() {
    const g = SG.types[sgState.sleeve], host = $('#sgTables'), unit = $('[data-sg-body]').dataset.unit;
    host.innerHTML = `<div><h3>Dimensions corporelles recommandées</h3>${tableHTML(g.body)}</div><div><h3>Dimensions du maillot</h3>${tableHTML(g.prod)}</div>${unit ? `<p class="unit">${esc(unit)}</p>` : ''}`;
  }
  function renderSg() {
    const body = $('[data-sg-body]'), d = body.dataset;
    const types = Object.keys(SG.types);
    body.innerHTML = `
      <button class="qv-close" type="button" data-qv-close aria-label="Fermer le guide">&#10005;</button>
      <div class="sg">
        <h2 class="caps">${esc(d.title || 'Guide des tailles')}</h2>
        <div class="seg" role="group" aria-label="Type de maillot">${types.map(k => `<button type="button" data-sleeve="${k}" aria-pressed="${k === sgState.sleeve}">${esc(SG.types[k].label)}</button>`).join('')}</div>
        <form class="finder" id="finder" novalidate>
          <h3>Trouve ta taille</h3>
          <p class="muted">${esc(d.intro || '')}</p>
          <div class="finder-fields">
            <label>Tour de poitrine<input inputmode="decimal" name="chest" placeholder="ex. 98" value="${esc(sgState.vals.chest)}"></label>
            <label>Tour de taille<input inputmode="decimal" name="waist" placeholder="ex. 82" value="${esc(sgState.vals.waist)}"></label>
            <label>Tour de hanches<input inputmode="decimal" name="hips" placeholder="ex. 98" value="${esc(sgState.vals.hips)}"></label>
          </div>
          <button class="btn" type="submit">Trouver ma taille</button>
          <div class="sg-out" id="sgOut" aria-live="polite"></div>
        </form>
        <div id="sgTables"></div>
      </div>`;
    renderSgTables();
  }
  function openGuide(root) {
    const dlg = $('#sg'); if (!dlg || !sgData()) return;
    sgState.root = root || null; sgState.hit = null;
    const p = root ? productData(root) : null;
    const name = p ? `${p.title} ${p.handle || ''}` : '';
    sgState.sleeve = /courte|short/i.test(name) ? 'short' : 'long';
    if (!SG.types[sgState.sleeve]) sgState.sleeve = Object.keys(SG.types)[0];
    renderSg(); dlg.showModal();
  }
  function pickSize(name) {
    const root = sgState.root; if (!root) return false;
    const group = $$('.opt', root).find(g => /^(taille|size)$/i.test(g.dataset.optionName || ''));
    const input = group && $$('input', group).find(i => i.value.toLowerCase() === name.toLowerCase());
    if (!input) return false;
    input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }
  function findMySize(form) {
    const out = $('#sgOut'), vals = {};
    for (const k of ['chest', 'waist', 'hips']) {
      sgState.vals[k] = form.elements[k].value;
      const raw = form.elements[k].value.trim().replace(',', '.');
      if (raw === '') continue;
      const v = parseFloat(raw);
      if (!isFinite(v) || v < 50 || v > 200) { out.innerHTML = `<p>La mesure « ${MLABEL[k].toLowerCase()} » semble incorrecte. Entre-la en centimètres, par exemple 98.</p>`; form.elements[k].focus(); return; }
      vals[k] = v;
    }
    if (vals.chest === undefined) { out.innerHTML = '<p>Entre au moins ton tour de poitrine.</p>'; form.elements.chest.focus(); return; }
    const res = Object.entries(vals).map(([k, v]) => ({ k, v, ...sizeFor(k, v) }));
    const best = Math.max(...res.map(r => r.i)), name = SG.sizes[best];
    sgState.hit = best;
    const detail = res.map(r => `${MLABEL[r.k]} ${String(r.v).replace('.', ',')} cm : ${SG.sizes[r.i]}`).join('. ') + '.';
    let tips = '';
    if (res.some(r => r.note)) tips += '<p>Une de tes mesures sort du tableau. Contacte-nous avant de commander.</p>';
    if (new Set(res.map(r => r.i)).size > 1) tips += "<p>Tes mesures ne tombent pas toutes dans la même taille, on retient la plus grande. Si tu préfères une compression plus serrée, tu peux descendre d'une taille.</p>";
    out.innerHTML = `<strong>Taille recommandée : ${esc(name)}</strong><p>${esc(detail)}</p>${tips}${sgState.root ? `<button class="btn" type="button" data-pick="${esc(name)}">Choisir la taille ${esc(name)}</button>` : ''}`;
    renderSgTables();
  }

  /* ---------------------------------------------------------- page modules */
  function initHero() {
    const media = $('[data-hero-media]'); if (!media || reduce || media.dataset.ready) return;
    media.dataset.ready = '1';
    let ticking = false;
    addEventListener('scroll', () => {
      if (ticking) return; ticking = true;
      requestAnimationFrame(() => { media.style.setProperty('--py', (Math.min(scrollY, innerHeight) * 0.18).toFixed(1) + 'px'); ticking = false; });
    }, { passive: true });
  }
  function initFeatures(scope) {
    $$('[data-features]', scope).forEach(root => {
      if (root.dataset.ready) return; root.dataset.ready = '1';
      const hs = $$('.hs', root), btns = $$('.fx-btn', root), panels = $$('.fx-panel', root);
      const set = i => {
        hs.forEach((h, k) => h.classList.toggle('on', k === i));
        btns.forEach((b, k) => b.setAttribute('aria-expanded', String(k === i)));
        panels.forEach((p, k) => p.classList.toggle('open', k === i));
      };
      hs.forEach((h, i) => { h.addEventListener('click', () => set(i)); h.addEventListener('mouseenter', () => set(i)); });
      btns.forEach((b, i) => b.addEventListener('click', () => set(i)));
      set(Math.min(1, hs.length - 1));
    });
  }
  const io = ('IntersectionObserver' in window) ? new IntersectionObserver(entries => {
    entries.forEach(en => {
      if (!en.isIntersecting) return;
      const el = en.target; el.classList.add('in');
      const c = $('[data-count-to]', el); if (c && el.classList.contains('count')) countUp(c);
      io.unobserve(el);
    });
  }, { threshold: 0.25 }) : null;
  function countUp(el) {
    const to = Number(el.dataset.countTo) || 0;
    if (reduce) { el.textContent = to; return; }
    const t0 = performance.now(), dur = 1600;
    (function step(t) {
      const k = Math.min((t - t0) / dur, 1);
      el.textContent = Math.round(to * (1 - Math.pow(1 - k, 3)));
      if (k < 1) requestAnimationFrame(step);
    })(t0);
  }
  function initReveal(scope) {
    $$('.rv, .count', scope).forEach(el => {
      if (el.dataset.io) return; el.dataset.io = '1';
      const c = $('[data-count-to]', el);
      if (reduce || !io) { el.classList.add('in'); if (c) c.textContent = c.dataset.countTo; return; }
      io.observe(el);
    });
  }
  function initReel(scope) {
    $$('[data-reel]', scope).forEach(reel => {
      if (reel.dataset.ready) return; reel.dataset.ready = '1';
      const slides = $$('[data-reel-slides] .slide', reel); if (!slides.length) return;
      const DUR = Number(reel.dataset.duration) || 4000;
      const bars = $('[data-reel-bars]', reel), cap = $('[data-reel-cap]', reel), toggle = $('[data-reel-toggle]', reel);
      bars.innerHTML = slides.map(() => '<i><b></b></i>').join('');
      const fills = $$('b', bars);
      slides.forEach(s => s.style.setProperty('--dur', DUR + 'ms'));
      let idx = 0, elapsed = 0, playing = !reduce, visible = false, last = 0;
      function show(i) {
        idx = (i + slides.length) % slides.length; elapsed = 0;
        slides.forEach((el, k) => {
          if (k === idx) { el.classList.remove('on'); void el.offsetWidth; el.classList.add('on'); } else el.classList.remove('on');
        });
        fills.forEach((b, k) => { b.style.width = k < idx ? '100%' : '0'; });
        const s = slides[idx];
        cap.innerHTML = '';
        const p = document.createElement('p'); p.className = 'caps'; p.textContent = s.dataset.caption || ''; cap.appendChild(p);
        if (s.dataset.ctaLabel) { const a = document.createElement('a'); a.className = 'btn'; a.href = s.dataset.ctaLink || '#catalogue'; a.textContent = s.dataset.ctaLabel; cap.appendChild(a); }
      }
      function setPlaying(v) {
        playing = v; toggle.innerHTML = v ? '&#10074;&#10074;' : '&#9654;';
        toggle.setAttribute('aria-label', v ? 'Mettre en pause' : 'Lire');
        slides.forEach(s => { const im = s.querySelector('img'); if (im) im.style.animationPlayState = v ? 'running' : 'paused'; });
      }
      const loop = t => {
        if (!reel.isConnected) return;
        if (playing && visible) {
          elapsed += t - last;
          fills[idx].style.width = Math.min(elapsed / DUR * 100, 100) + '%';
          if (elapsed >= DUR) show(idx + 1);
        }
        last = t; requestAnimationFrame(loop);
      };
      $('[data-reel-next]', reel).addEventListener('click', () => show(idx + 1));
      $('[data-reel-prev]', reel).addEventListener('click', () => show(idx - 1));
      toggle.addEventListener('click', () => setPlaying(!playing));
      reel.addEventListener('keydown', e => { if (e.key === 'ArrowRight') show(idx + 1); if (e.key === 'ArrowLeft') show(idx - 1); });
      if ('IntersectionObserver' in window) new IntersectionObserver(en => { visible = en[0].isIntersecting; }, { threshold: 0.4 }).observe(reel); else visible = true;
      show(0); setPlaying(playing); requestAnimationFrame(t => { last = t; requestAnimationFrame(loop); });
    });
  }
  function initProducts(scope) { $$('[data-product-root]', scope).forEach(r => updateVariant(r, { keepUrl: true })); }
  function initAll(scope = document) { initHero(); initFeatures(scope); initReveal(scope); initReel(scope); initProducts(scope); }

  /* ---------------------------------------------------------- global events */
  document.addEventListener('click', e => {
    const t = e.target;
    if (!(t instanceof Element)) return;
    if (t.matches('dialog')) { t.close(); return; }
    if (t.closest('[data-cart-open]')) { e.preventDefault(); setDrawer(true); return; }
    if (t.closest('[data-cart-close]')) { setDrawer(false); return; }
    if (t.closest('[data-qv-close]')) { const d = t.closest('dialog'); if (d) d.close(); return; }
    const qv = t.closest('[data-quickview]');
    if (qv && !(e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button)) { e.preventDefault(); openQV(qv.dataset.quickview); return; }
    const thumb = t.closest('.qv-thumbs button');
    if (thumb) { setMedia(thumb.closest('[data-product-root]'), thumb); return; }
    const guide = t.closest('[data-size-guide]');
    if (guide) { openGuide(guide.closest('[data-product-root]')); return; }
    const sl = t.closest('[data-sleeve]');
    if (sl) { sgState.sleeve = sl.dataset.sleeve; $$('[data-sleeve]').forEach(b => b.setAttribute('aria-pressed', String(b === sl))); renderSgTables(); return; }
    const pick = t.closest('[data-pick]');
    if (pick) { if (pickSize(pick.dataset.pick)) { $('#sg').close(); toast(`Taille ${pick.dataset.pick} sélectionnée`); } else toast("Cette taille n'est pas proposée pour ce produit."); return; }
    const step = t.closest('[data-qty-step]');
    if (step) { const input = $('[data-qty-input]', step.closest('.qty')); changeLine(step.dataset.line, Math.max(0, Number(input.value) + Number(step.dataset.qtyStep))); return; }
    const rm = t.closest('[data-remove]');
    if (rm) { changeLine(rm.dataset.line, 0); return; }
    const rn = t.closest('[data-rail-next], [data-rail-prev]');
    if (rn) {
      const rail = $('[data-rail]', rn.closest('section'));
      if (rail) rail.scrollBy({ left: (rn.hasAttribute('data-rail-next') ? 1 : -1) * rail.clientWidth * 0.7, behavior: reduce ? 'auto' : 'smooth' });
    }
  });
  document.addEventListener('change', e => {
    const t = e.target;
    if (t.matches('.opt input[type=radio]')) updateVariant(t.closest('[data-product-root]'));
    else if (t.matches('[data-qty-input]')) changeLine(t.dataset.line, Math.max(0, Number(t.value) || 0));
  });
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && document.body.classList.contains('cart-open')) setDrawer(false);
    if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-qty-input]')) { e.preventDefault(); changeLine(e.target.dataset.line, Math.max(0, Number(e.target.value) || 0)); }
  });
  document.addEventListener('submit', e => {
    const f = e.target;
    if (f.matches('[data-product-form]')) { e.preventDefault(); addToCart(f); }
    else if (f.matches('[data-alert-form]')) { e.preventDefault(); sendAlert(f); }
    else if (f.id === 'finder') { e.preventDefault(); findMySize(f); }
  });
  document.addEventListener('shopify:section:load', e => initAll(e.target));

  applyDrawerState();
  initAll();
})();
